<template>
  <div class="p-3 flex flex-col gap-3">
    <div class="mb-0">
      <div>
        <label for="inputs-extension">Extension Number</label>
        <vs-input v-model="inputs.extension"/>
      </div>
    </div>

    <div class="flex flex-col justify-center items-center gap-3" v-if="_queues.length > 0">
      <div
        v-for="(queueItem, key) in _queues"
        :key="key"
        class="w-full border-black border-2 border-dashed p-3 font-bold"
      >
        <h3 class="mb-3" v-text="queueItem.queue.label"></h3>
        <ul class="grid auto-rows-auto grid-cols-10 min-h-full w-100 gap-3 queue-all">
          <li
            :class="`flex flex-col justify-center items-start p-2 gap-1 queue-status-${$queueHelper.getColorByStatus(ext.status)}`"
            v-for="(ext, key) in queueItem.extensions"
            :key="key"
          >
            <p class="border-b-2" v-text="ext.extension"></p>
            <p
              :class="`callstatus-${ext.status}-text`"
              v-html="(ext.text !== null && ext.text.length > 0) ? (ext.status === '4') ? '연결 안됨' : ext.text : '--'"
            ></p>
            <p v-html="ext.name !== null && ext.name.length > 0 ? ext.name : '--'"></p>
            <p v-html="ext.time"></p>
            <div class="flex justify-start items-center gap-3">
              <div @click.prevent="listen(ext.extension)">
                <vx-tooltip :text="$t('listen')" position="bottom">
                  <img
                    src="@/assets/images/listen.png"
                    :class="{ 'active-cti-status-button': ctiState.listen &&  ctiState.activeCtiExtension === ext.extension}"
                    style="width: 32px; display: inline; cursor:pointer;"
                  >
                </vx-tooltip>
              </div>

              <div @click.prevent="whisper(ext.extension)">
                <vx-tooltip :text="$t('whisper')" position="bottom">
                  <img
                    src="@/assets/images/whisper.png"
                    :class="{ 'active-cti-status-button': ctiState.whisper &&  ctiState.activeCtiExtension === ext.extension}"
                    style="width: 32px; display: inline; cursor:pointer;"
                  >
                </vx-tooltip>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <!-- Queue -->
    </div>
    <!-- Queue Container -->
  </div>
</template>

<script>
import io from 'socket.io-client'
import Moment from 'moment'
import Cti from '@/models/Cti'
import Node from '@/models/Node'
import User from '@/models/User'
import Queue from '@/models/Queue'

export default {
  name: 'Window.Queues.Status.All',
  data () {
    return {
      socket: {},
      server: {},
      queueStatusNode: {},
      extensions: [],
      queueLabels: [],
      ctiState: {
        listen: false,
        whisper: false,
        activeCtiExtension: null
      },
      inputs: {
        extension: '',
      },
    }
  },
  computed: {
    queues () {
      return this.$route.query.queues
    },
    _queues () {
      return this.extensions.reduce((acc, item) => {
        const queueIndex = acc.findIndex((obj) => obj.queue.number === item.queue)

        if (queueIndex === -1) {
          acc.push({
            queue: {
              number: item.queue,
              label: this.queueLabels[item.queue]
            },
            extensions: [item]
          })
        } else {
          acc[queueIndex].extensions.push(item)
        }

        return acc
      }, [])
    }
  },
  async mounted () {
    const response = await Node.getServerAndNodeByLoggedInUser()
    this.server = response.data.server
    this.queueStatusNode = response.data.server.queue_status

    const socketUrl = `${this.queueStatusNode.domain}:${this.queueStatusNode.port}/${this.queueStatusNode.pivot.namespace}`
    const socketOptions = { query: { queueno: this.queues }, transports: ['websocket'] }

    this.socket = io.connect(socketUrl, socketOptions)

    this.socket.on('connect', this.getInitialExtensions)
    this.socket.on('draw-initial-extensions', this.drawInitialExtensions)
    this.socket.on('message', this.getMessage)
  },
  methods: {
    getInitialExtensions () {
      this.socket.emit('get-initial-extensions')
    },
    async drawInitialExtensions (data) {
      const queueResponse = await Queue.all()
      this.queueLabels = queueResponse.data.queues.reduce((acc, item) => {
        acc[item.number] = item.label
        return acc
      }, {})

      this.extensions = data.reduce((acc, item) => {
        acc.push({
          extension: item.extensions,
          queue: item.queue_no,
          name: '',
          color: '',
          status: '',
          text: '',
          time: '00:00:00',
          dndTime: '00:00:00',
          tempStatus: false,
          enabled: false,
          rest: 0,
          lunch: 0,
          wrapup: 0,
          ready: 0,
          total: 0,
          inOrOut: '',
          displayInOrOut: false
        })
        return acc
      }, [])

      await this.showAgentNames()
    },
    getMessage (data) {
      if (data.api_type === 'status') {
        this.manageStatus(data)
      }
    },
    async showAgentNames () {
      const response = await User.showAgentNames({ extensions: this.extensions.map(item => item.extension) })

      response.data.result.map((item) => {
        const extensionIndex = this.extensions.findIndex((obj) => obj.extension === item.extension_number)
        this.extensions[extensionIndex].name = item.name
      })
    },
    async manageStatus (data) {
      const now = new Moment() // eslint-disable-line new-cap

      this.extensions.map((obj) => {
        const extensionIndex = data.extensions.indexOf(obj.extension)

        if (extensionIndex !== -1) {
          obj.color = data.color[extensionIndex]
          obj.status = data.status[extensionIndex]
          obj.text = data.text[extensionIndex]
          obj.time = data.time[extensionIndex]
          obj.inOrOut = data.inOrOut[extensionIndex]
          obj.displayInOrOut = data.displayInOrOut[extensionIndex]

          let socketStatus = null

          switch (parseInt(obj.status)) {
          case 11:
            socketStatus = 11
            if (obj.tempStatus !== 11) {
              obj.dndTime = new Moment() // eslint-disable-line new-cap
            }
            break
          case 21:
            socketStatus = 21
            if (obj.tempStatus !== 21) {
              obj.dndTime = new Moment() // eslint-disable-line new-cap
            }
            break
          case 31:
            socketStatus = 31
            if (obj.tempStatus !== 31) {
              obj.dndTime = new Moment() // eslint-disable-line new-cap
            }
            break
          case 32:
          case 22:
          case 12:
          case 0:
            socketStatus = 32
            if (obj.tempStatus !== 32) {
              obj.dndTime = new Moment() // eslint-disable-line new-cap
            }
            break
          default:
            socketStatus = null
            obj.dndTime = null
          }

          obj.tempStatus = socketStatus

          if (data.time[extensionIndex] === '&nbsp;') {
            const duration = Moment.duration(now.diff(obj.dndTime))
            const dndTime = `${duration._data.hours.toString().padStart(2, '0')}:${duration._data.minutes.toString().padStart(2, '0')}:${duration._data.seconds.toString().padStart(2, '0')}`

            if (obj.tempStatus !== null) {
              obj.time = dndTime
            }
          }

          obj.enabled = [11, 21, 31].indexOf(parseInt(data.status[extensionIndex])) !== -1
        }

        return obj
      })
    },
    async listen(extension) {
      if (this.ctiState.listen === false) {
        if (this.ctiState.whisper === true) {
          this.$swalHelper.displayCatchError({
            title: 'Error!',
            errorObject: `Current state is whispering to ${this.ctiState.activeCtiExtension}`,
            confirmButton: this.$t('confirm')
          })
        } else {
          try {
            await Cti.listen(this.server.domain, {
              extension: this.inputs.extension,
              channel: extension
            })
            this.ctiState.activeCtiExtension = extension
            this.ctiState.listen = true
          } catch (e) {
            this.$vs.notify({
              title:'CTI Notice',
              text:'Listen Error',
              color:'danger',
              position:'top-right'
            })
          }
        }
      } else if (this.ctiState.listen === true) {
        if (this.ctiState.activeCtiExtension === extension) {
          this.ctiState.listen = false
          await Cti.hangupWithChannel(this.server.domain, this.inputs.extension)
        } else {
          this.$swalHelper.displayCatchError({
            title: 'Error!',
            errorObject: `Current state is listening to ${this.ctiState.activeCtiExtension}`,
            confirmButton: this.$t('confirm')
          })
        }
      }
    },
    async whisper(extension) {
      if (this.ctiState.whisper === false) {
        if (this.ctiState.listen === true) {
          this.$swalHelper.displayCatchError({
            title: 'Error!',
            errorObject: `Current state is listening to ${this.ctiState.activeCtiExtension}`,
            confirmButton: this.$t('confirm')
          })
        } else {
          await Cti.whisper(this.server.domain, {
            extension: this.inputs.extension,
            channel: extension
          })
          this.ctiState.activeCtiExtension = extension
          this.ctiState.whisper = true
        }
      } else if (this.ctiState.whisper === true) {
        if (this.ctiState.activeCtiExtension === extension) {
          this.ctiState.whisper = false
          await Cti.hangupWithChannel(this.server.domain, this.inputs.extension)
        } else {
          this.$swalHelper.displayCatchError({
            title: 'Error!',
            errorObject: `Current state is whispering to ${this.ctiState.activeCtiExtension}`,
            confirmButton: this.$t('confirm')
          })
        }
      }
    }
  }
}
</script>

<style lang="scss">
@import "~@/assets/scss/user/_variables.scss";

.queue-all {
  > li {
    border: 1px solid;
  }
  .queue-status-default,
  .queue-status-rest,
  .queue-status-lunch,
  .queue-status-after,
  .queue-status-consultation-available {
    border-color: $default-color;
    color: $default-color;
  }
  .queue-status-busy {
    border-color: $busy-color;
    color: $busy-color;
  }
  .queue-status-logout {
    border-color: $logout-color;
    color: $logout-color;
  }
  .queue-status-ringing {
    border-color: $ringing-color;
    color: $ringing-color;
  }
}
</style>
